import './materializeInput.scss';

export default function materializeInput() {
    const getEl = document.getElementsByClassName('form-group-material');

    Array.from(getEl).forEach(ele => {
        const input = ele.querySelector('input');

        if (input) {
            const inputVal = input.value;

            if (inputVal) {
                ele.classList.add('active');
            }

            input.addEventListener('click', event => {
                const parent = event.target.parentNode;
                parent.classList.add('active');
            });
        }
    });
}
